import { useEffect, useState, type MouseEvent } from 'react';
import clsx from 'clsx';
import { PaletteUtils } from '@shared/utils';
import { DropDownIcon } from '@shared/widgets';

interface ViewProps {
  className?: string;
  mode: 'view' | 'item';
  index?: number;
  active?: boolean;
  value: any;
  onClick?: (e: MouseEvent<HTMLDivElement>, value: any) => void;
}

export const View = (props: ViewProps) => {
  const [isAnimating, setIsAnimating] = useState(false);
  const isSticker = props.mode === 'item' && props.index == 0;
  const showDropdownIcon = isSticker || props.mode !== 'item';

  useEffect(() => {
    setIsAnimating(true);
    const timer = setTimeout(() => setIsAnimating(false), 300);
    return () => clearTimeout(timer);
  }, [props.value]);

  return (
    <div
      className={clsx(
        'group',
        'align-center items-center cursor-pointer flex h-[82px] flex-row flex-nowrap text-[16px] font-[900] justify-between tracking-[0.3px] leading-[24px] py-0 px-[20px] text-left ',
        props.className,
        {
          'max-sm:pr-[20px]': props.mode !== 'item',
        },
        isAnimating && 'appear',
        props.mode !== 'view' && (PaletteUtils.isBordierPalette ? 'border-y border-[#555558]' : 'max-[840px]:border border-[#555558]'),
        props.mode === 'item' && (PaletteUtils.isBordierPalette ? 'bg-white' : 'bg-[#35353a] '),
        props.active && (PaletteUtils.isBordierPalette ? '!bg-[#f1f1f1]' : '!bg-[#1e1e21]'),
      )}
      onClick={(e) => props.onClick?.(e, props.value)}
    >
      <div className='max-[840px]:flex max-[840px]:justify-between max-[840px]:w-full max-[840px]:pr-2.5'>
        <div className={clsx(PaletteUtils.isBordierPalette ? 'text-[#27272b]' : 'text-[#dadada] group-hover:text-[#e5c496]')}>
          {props.value?.name}
        </div>
        <div
          className={clsx(
            ' flex justify-between font-[400] tracking-[0.5px] w-full uppercase',
            PaletteUtils.isBordierPalette ? 'text-[#27272b]' : 'text-[#8c8c8d]',
          )}
        >
          {props.value?.cardNumber}
        </div>
        <div className={clsx('text-[80%]', PaletteUtils.isBordierPalette ? 'text-[#27272b]' : 'text-[#dadada] font-medium')}>
          {props.value?.cardType}
        </div>
      </div>

      {showDropdownIcon && props.mode !== 'view' && (
        <DropDownIcon
          className={clsx(
            '!h-[9px] !w-[15px]',
            PaletteUtils.isBordierPalette
              ? 'text-[#dc291c] hover:text-[#4c4c52]'
              : ` ${props.mode === 'item' && 'text-[#e5c496]'} group-hover:text-[#e5c496]`,
          )}
          isOpen={isSticker}
        />
      )}
    </div>
  );
};
